export var PermissionType;
(function (PermissionType) {
    // Admin Permission
    // 平台公告管理
    PermissionType[PermissionType["ANNOUNCEMENT_READ"] = 3] = "ANNOUNCEMENT_READ";
    // 平台公告管理 - 編輯
    PermissionType[PermissionType["ANNOUNCEMENT"] = 2] = "ANNOUNCEMENT";
    // 經銷公告
    PermissionType[PermissionType["AGENT_ANNOUNCEMENT_READ"] = 15] = "AGENT_ANNOUNCEMENT_READ";
    // 經銷公告 - 編輯
    PermissionType[PermissionType["AGENT_ANNOUNCEMENT"] = 14] = "AGENT_ANNOUNCEMENT";
    // 系統信息
    PermissionType[PermissionType["NOTIFICATION_SETTING_READ"] = 7] = "NOTIFICATION_SETTING_READ";
    // 系統信息 - 編輯
    PermissionType[PermissionType["NOTIFICATION_SETTING"] = 6] = "NOTIFICATION_SETTING";
    // 站內信
    PermissionType[PermissionType["SEND_MESSAGE_READ"] = 9] = "SEND_MESSAGE_READ";
    // 站內信 - 編輯
    PermissionType[PermissionType["SEND_MESSAGE"] = 8] = "SEND_MESSAGE";
    // 站內信 - 模板管理
    PermissionType[PermissionType["SEND_MESSAGE_TEMPLATE"] = 16] = "SEND_MESSAGE_TEMPLATE";
    // 短信紀錄
    PermissionType[PermissionType["SMS_RECORD_READ"] = 11] = "SMS_RECORD_READ";
    // 短信紀錄 - 短信商管理
    PermissionType[PermissionType["SMS_PROVIDER"] = 17] = "SMS_PROVIDER";
    // 短信紀錄 - 重發
    PermissionType[PermissionType["SMS_RECORD_RESEND"] = 10] = "SMS_RECORD_RESEND";
    // 合營計畫聯繫方式設定
    PermissionType[PermissionType["JOINT_VENTURE_LINK_SETTING_READ"] = 19] = "JOINT_VENTURE_LINK_SETTING_READ";
    // 合營計畫聯繫方式設定 - 編輯
    PermissionType[PermissionType["JOINT_VENTURE_LINK_SETTING"] = 18] = "JOINT_VENTURE_LINK_SETTING";
    // 橫幅通知管理
    PermissionType[PermissionType["BANNER_NOTIFICATION_READ"] = 21] = "BANNER_NOTIFICATION_READ";
    // 橫幅通知管理 - 編輯
    PermissionType[PermissionType["BANNER_NOTIFICATION"] = 20] = "BANNER_NOTIFICATION";
    // 下載連結設定
    PermissionType[PermissionType["FORWARDER_DOWNLOAD_LINK_SETTING_READ"] = 13] = "FORWARDER_DOWNLOAD_LINK_SETTING_READ";
    // 下載連結設定 - 編輯
    PermissionType[PermissionType["FORWARDER_DOWNLOAD_LINK_SETTING"] = 12] = "FORWARDER_DOWNLOAD_LINK_SETTING";
    // 外接遊戲設定
    PermissionType[PermissionType["EXTERNAL_GAME_SETTING_READ"] = 101] = "EXTERNAL_GAME_SETTING_READ";
    // 外接遊戲設定 - 編輯
    PermissionType[PermissionType["EXTERNAL_GAME_SETTING"] = 100] = "EXTERNAL_GAME_SETTING";
    // 返水設定
    PermissionType[PermissionType["FEEDBACK_SETTING_READ"] = 105] = "FEEDBACK_SETTING_READ";
    // 返水設定 - 編輯
    PermissionType[PermissionType["FEEDBACK_SETTING"] = 104] = "FEEDBACK_SETTING";
    // 遊戲設定
    PermissionType[PermissionType["CHANNEL_SETTING_READ"] = 107] = "CHANNEL_SETTING_READ";
    // 遊戲設定 - 編輯
    PermissionType[PermissionType["CHANNEL_SETTING"] = 106] = "CHANNEL_SETTING";
    // 大總監管理
    PermissionType[PermissionType["EMPEROR_MANAGEMENT_READ"] = 151] = "EMPEROR_MANAGEMENT_READ";
    // 大總監管理 - 編輯
    PermissionType[PermissionType["EMPEROR_MANAGEMENT"] = 150] = "EMPEROR_MANAGEMENT";
    // 管理層級錢包
    PermissionType[PermissionType["AGENT_WALLET_MANAGEMENT_READ"] = 179] = "AGENT_WALLET_MANAGEMENT_READ";
    // 管理層級錢包 - 編輯
    PermissionType[PermissionType["AGENT_WALLET_MANAGEMENT"] = 178] = "AGENT_WALLET_MANAGEMENT";
    // 代理日誌
    PermissionType[PermissionType["AGENT_OPERATION_LOG_READ"] = 109] = "AGENT_OPERATION_LOG_READ";
    // 登錄 IP 位址
    PermissionType[PermissionType["LOGIN_IP_SEARCH_READ"] = 155] = "LOGIN_IP_SEARCH_READ";
    // 遊戲登錄紀錄
    PermissionType[PermissionType["PLAYER_GAME_LOGIN_HISTORY_READ"] = 185] = "PLAYER_GAME_LOGIN_HISTORY_READ";
    // IP 監控
    PermissionType[PermissionType["PLAYER_IP_MONITORING_HISTORY_READ"] = 187] = "PLAYER_IP_MONITORING_HISTORY_READ";
    // 會員轉線
    PermissionType[PermissionType["PLAYER_JUMP_SHIP_READ"] = 157] = "PLAYER_JUMP_SHIP_READ";
    // 會員轉線 - 編輯
    PermissionType[PermissionType["PLAYER_JUMP_SHIP"] = 156] = "PLAYER_JUMP_SHIP";
    // 會員管理
    PermissionType[PermissionType["PLAYER_MANAGEMENT_READ"] = 159] = "PLAYER_MANAGEMENT_READ";
    // 會員管理 - 會員信息
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_READ"] = 161] = "PLAYER_MANAGEMENT_INFO_READ";
    // 會員管理 - 會員信息 - 編輯 FM 備註
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_FM_MEMO"] = 193] = "PLAYER_MANAGEMENT_INFO_FM_MEMO";
    // 會員管理 - 會員信息 - 編輯 RC 備註
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_RC_MEMO"] = 194] = "PLAYER_MANAGEMENT_INFO_RC_MEMO";
    // 會員管理 - 會員信息 - 編輯 CS 備註
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_CS_MEMO"] = 195] = "PLAYER_MANAGEMENT_INFO_CS_MEMO";
    // 會員管理 - 會員信息 - 編輯手機號碼
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_PHONE"] = 191] = "PLAYER_MANAGEMENT_INFO_PHONE";
    // 會員管理 - 會員信息 - 編輯暱稱
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_NICKNAME"] = 160] = "PLAYER_MANAGEMENT_INFO_NICKNAME";
    // 會員管理 - 會員信息 - 編輯電子郵箱
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_EMAIL"] = 192] = "PLAYER_MANAGEMENT_INFO_EMAIL";
    // 會員管理 - 會員信息 - 解除購寶綁定
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_GOUBAO_UNBIND"] = 197] = "PLAYER_MANAGEMENT_INFO_GOUBAO_UNBIND";
    // 會員管理 - 會員權限設定
    PermissionType[PermissionType["PLAYER_MANAGEMENT_PERMISSION_READ"] = 163] = "PLAYER_MANAGEMENT_PERMISSION_READ";
    // 會員管理 - 會員權限設定 - 編輯
    PermissionType[PermissionType["PLAYER_MANAGEMENT_PERMISSION"] = 162] = "PLAYER_MANAGEMENT_PERMISSION";
    // 會員管理 - 會員中心設定
    PermissionType[PermissionType["PLAYER_MANAGEMENT_CENTER_READ"] = 165] = "PLAYER_MANAGEMENT_CENTER_READ";
    // 會員管理 - 會員中心設定 - 編輯
    PermissionType[PermissionType["PLAYER_MANAGEMENT_CENTER"] = 164] = "PLAYER_MANAGEMENT_CENTER";
    // 會員管理 - 會員提現帳號信息
    PermissionType[PermissionType["PLAYER_MANAGEMENT_WITHDRAWAL_ACCOUNT_READ"] = 199] = "PLAYER_MANAGEMENT_WITHDRAWAL_ACCOUNT_READ";
    // 會員管理 - 會員提現帳號信息 - 編輯
    PermissionType[PermissionType["PLAYER_MANAGEMENT_WITHDRAWAL_ACCOUNT"] = 198] = "PLAYER_MANAGEMENT_WITHDRAWAL_ACCOUNT";
    // 會員管理 - 會員提現帳號信息 - 綁定帳號
    PermissionType[PermissionType["PLAYER_MANAGEMENT_WITHDRAWAL_ACCOUNT_BIND"] = 190] = "PLAYER_MANAGEMENT_WITHDRAWAL_ACCOUNT_BIND";
    // 會員管理 - 會員帳戶信息
    PermissionType[PermissionType["PLAYER_MANAGEMENT_DEBIT_CARD_READ"] = 167] = "PLAYER_MANAGEMENT_DEBIT_CARD_READ";
    // 會員管理 - 會員帳戶信息 - 編輯
    PermissionType[PermissionType["PLAYER_MANAGEMENT_DEBIT_CARD"] = 166] = "PLAYER_MANAGEMENT_DEBIT_CARD";
    // 會員管理 - 會員帳戶信息 - 綁定帳戶
    PermissionType[PermissionType["PLAYER_MANAGEMENT_DEBIT_CARD_BIND"] = 196] = "PLAYER_MANAGEMENT_DEBIT_CARD_BIND";
    // 會員管理 - 虚拟币地址信息
    PermissionType[PermissionType["PLAYER_MANAGEMENT_CRYPTO_WALLET_READ"] = 181] = "PLAYER_MANAGEMENT_CRYPTO_WALLET_READ";
    // 會員管理 - 虚拟币地址信息 - 編輯
    PermissionType[PermissionType["PLAYER_MANAGEMENT_CRYPTO_WALLET"] = 180] = "PLAYER_MANAGEMENT_CRYPTO_WALLET";
    // 會員管理 - 上下點統計
    PermissionType[PermissionType["PLAYER_MANAGEMENT_TRANSACTION_READ"] = 169] = "PLAYER_MANAGEMENT_TRANSACTION_READ";
    // 會員管理 - 平台錢包統計
    PermissionType[PermissionType["PLAYER_MANAGEMENT_WALLET_READ"] = 171] = "PLAYER_MANAGEMENT_WALLET_READ";
    // 會員管理 - 關聯會員 - 編輯
    PermissionType[PermissionType["PLAYER_MANAGEMENT_INFO_RELATION"] = 172] = "PLAYER_MANAGEMENT_INFO_RELATION";
    // 會員管理 - 管理層級備註 - RC - 編輯
    PermissionType[PermissionType["PLAYER_MANAGEMENT_AGENTS_MEMO_RC_EDIT"] = 173] = "PLAYER_MANAGEMENT_AGENTS_MEMO_RC_EDIT";
    // 會員管理 - 管理層級備註 - RC - 查看
    PermissionType[PermissionType["PLAYER_MANAGEMENT_AGENTS_MEMO_RC_READ"] = 174] = "PLAYER_MANAGEMENT_AGENTS_MEMO_RC_READ";
    // 會員管理 - 管理層級備註 - CS - 編輯
    PermissionType[PermissionType["PLAYER_MANAGEMENT_AGENTS_MEMO_CS_EDIT"] = 206] = "PLAYER_MANAGEMENT_AGENTS_MEMO_CS_EDIT";
    // 會員管理 - 管理層級備註 - CS - 查看
    PermissionType[PermissionType["PLAYER_MANAGEMENT_AGENTS_MEMO_CS_READ"] = 207] = "PLAYER_MANAGEMENT_AGENTS_MEMO_CS_READ";
    // 等級管理
    PermissionType[PermissionType["PLAYER_RANK_MANAGEMENT_READ"] = 177] = "PLAYER_RANK_MANAGEMENT_READ";
    // 等級管理 - 編輯
    PermissionType[PermissionType["PLAYER_RANK_MANAGEMENT"] = 176] = "PLAYER_RANK_MANAGEMENT";
    // 層級管理
    PermissionType[PermissionType["PLAYER_LAYER_MANAGEMENT_READ"] = 153] = "PLAYER_LAYER_MANAGEMENT_READ";
    // 層級管理 - 修改層級
    PermissionType[PermissionType["PLAYER_LAYER_MANAGEMENT"] = 152] = "PLAYER_LAYER_MANAGEMENT";
    // 層級管理 - 統計歸零
    PermissionType[PermissionType["PLAYER_LAYER_STATISTIC_ZERO"] = 125] = "PLAYER_LAYER_STATISTIC_ZERO";
    // 層級管理 - 重新分層
    PermissionType[PermissionType["PLAYER_LAYER_RESET_LAYER"] = 126] = "PLAYER_LAYER_RESET_LAYER";
    // 層級管理 - 設定會員層級
    PermissionType[PermissionType["PLAYER_LAYER_SET_PLAYER"] = 127] = "PLAYER_LAYER_SET_PLAYER";
    // 會員升級流水
    PermissionType[PermissionType["PLAYER_RANK_EFFECTIVE_BET_READ"] = 183] = "PLAYER_RANK_EFFECTIVE_BET_READ";
    // 會員升級流水 - 編輯
    PermissionType[PermissionType["PLAYER_RANK_EFFECTIVE_BET"] = 182] = "PLAYER_RANK_EFFECTIVE_BET";
    // 會員日誌
    PermissionType[PermissionType["PLAYER_MANAGEMENT_PLAYER_LOG_READ"] = 189] = "PLAYER_MANAGEMENT_PLAYER_LOG_READ";
    // 團隊盈虧
    PermissionType[PermissionType["COMPANY_PROFIT_RECORD_READ"] = 469] = "COMPANY_PROFIT_RECORD_READ";
    // 個人盈虧
    PermissionType[PermissionType["PROFIT_RECORD_READ"] = 457] = "PROFIT_RECORD_READ";
    // 個人盈虧 - 匯出
    PermissionType[PermissionType["PROFIT_RECORD_EXPORT"] = 456] = "PROFIT_RECORD_EXPORT";
    // 金流次數統計
    PermissionType[PermissionType["DEPOSIT_STATISTIC_RECORD_READ"] = 473] = "DEPOSIT_STATISTIC_RECORD_READ";
    // 新進人數統計
    PermissionType[PermissionType["NEW_PEOPLE_STATISTIC_RECORD_READ"] = 475] = "NEW_PEOPLE_STATISTIC_RECORD_READ";
    // 返水紀錄
    PermissionType[PermissionType["FEEDBACK_HISTORY"] = 478] = "FEEDBACK_HISTORY";
    // 出入帳目匯總
    PermissionType[PermissionType["IN_AND_OUT_RECORD_READ"] = 483] = "IN_AND_OUT_RECORD_READ";
    // 平台費統計
    PermissionType[PermissionType["PLATFORM_FEE_RECORD_READ"] = 487] = "PLATFORM_FEE_RECORD_READ";
    // 會員排行榜
    PermissionType[PermissionType["PLAYER_LEADERBOARD_READ"] = 496] = "PLAYER_LEADERBOARD_READ";
    // 總輸贏快照
    PermissionType[PermissionType["REVENUE_TREND_READ"] = 482] = "REVENUE_TREND_READ";
    // 遊戲紀錄
    PermissionType[PermissionType["BET_RECORD_READ"] = 451] = "BET_RECORD_READ";
    // 遊戲紀錄 - 匯出
    PermissionType[PermissionType["BET_RECORD_EXPORT"] = 450] = "BET_RECORD_EXPORT";
    // 遊戲紀錄回補
    PermissionType[PermissionType["BET_RECORD_FETCH_READ"] = 461] = "BET_RECORD_FETCH_READ";
    // 遊戲紀錄回補 - 回補
    PermissionType[PermissionType["BET_RECORD_FETCH"] = 460] = "BET_RECORD_FETCH";
    // 轉點紀錄
    PermissionType[PermissionType["TRANSFER_RECORD_READ"] = 453] = "TRANSFER_RECORD_READ";
    // 轉點紀錄 - 轉點
    PermissionType[PermissionType["TRANSFER_RECORD_TRANSFER"] = 495] = "TRANSFER_RECORD_TRANSFER";
    // 轉點紀錄 - 審核
    PermissionType[PermissionType["TRANSFER_RECORD_REVIEW"] = 452] = "TRANSFER_RECORD_REVIEW";
    // 帳變紀錄
    PermissionType[PermissionType["CASH_LOG_RECORD_READ"] = 455] = "CASH_LOG_RECORD_READ";
    // 會員點數帳
    PermissionType[PermissionType["CASH_ACCOUNTING_READ"] = 459] = "CASH_ACCOUNTING_READ";
    // 輸贏分析
    PermissionType[PermissionType["PLAYER_REPORT_WINLOSSANALYZE"] = 462] = "PLAYER_REPORT_WINLOSSANALYZE";
    // G幣交易紀錄
    PermissionType[PermissionType["PLAYER_REPORT_GASH_TRANSACTION_RECORD"] = 463] = "PLAYER_REPORT_GASH_TRANSACTION_RECORD";
    PermissionType[PermissionType["PLAYER_REPORT_GASH_TRANSACTION_RECORD_EDIT"] = 466] = "PLAYER_REPORT_GASH_TRANSACTION_RECORD_EDIT";
    PermissionType[PermissionType["PLAYER_REPORT_GASH_TRANSACTION_RECORD_EXPORT"] = 467] = "PLAYER_REPORT_GASH_TRANSACTION_RECORD_EXPORT";
    // FM 設定
    PermissionType[PermissionType["FINANCE_SETTING_READ"] = 223] = "FINANCE_SETTING_READ";
    // FM 設定 - 編輯
    PermissionType[PermissionType["FINANCE_SETTING"] = 222] = "FINANCE_SETTING";
    // 帳戶設定
    PermissionType[PermissionType["PIGGY_BANK_MANAGEMENT_READ"] = 215] = "PIGGY_BANK_MANAGEMENT_READ";
    // 帳戶設定 - 編輯
    PermissionType[PermissionType["PIGGY_BANK_MANAGEMENT"] = 214] = "PIGGY_BANK_MANAGEMENT";
    // 微信帳戶管理
    PermissionType[PermissionType["PIGGY_WECHAT_MANAGEMENT_READ"] = 217] = "PIGGY_WECHAT_MANAGEMENT_READ";
    // 微信帳戶管理 - 編輯
    PermissionType[PermissionType["PIGGY_WECHAT_MANAGEMENT"] = 216] = "PIGGY_WECHAT_MANAGEMENT";
    // 支付寶帳戶設定
    PermissionType[PermissionType["PIGGY_ALIPAY_MANAGEMENT_READ"] = 219] = "PIGGY_ALIPAY_MANAGEMENT_READ";
    // 支付寶帳戶設定 - 編輯
    PermissionType[PermissionType["PIGGY_ALIPAY_MANAGEMENT"] = 218] = "PIGGY_ALIPAY_MANAGEMENT";
    // 發行單位設定
    PermissionType[PermissionType["BANK_SETTING_READ"] = 211] = "BANK_SETTING_READ";
    // 發行單位設定 - 編輯
    PermissionType[PermissionType["BANK_SETTING"] = 210] = "BANK_SETTING";
    // 發行單位設定 - 三方代碼
    PermissionType[PermissionType["BANK_SETTING_CODE"] = 226] = "BANK_SETTING_CODE";
    // 第三方商家設定
    PermissionType[PermissionType["FINANCE_FORWARDER_READ"] = 225] = "FINANCE_FORWARDER_READ";
    // 第三方商家設定 - 編輯
    PermissionType[PermissionType["FINANCE_FORWARDER"] = 224] = "FINANCE_FORWARDER";
    // 上點渠道
    PermissionType[PermissionType["THIRD_PARTY_PAYMENT_SETTING_READ"] = 201] = "THIRD_PARTY_PAYMENT_SETTING_READ";
    // 上點渠道 - 編輯
    PermissionType[PermissionType["THIRD_PARTY_PAYMENT_SETTING"] = 200] = "THIRD_PARTY_PAYMENT_SETTING";
    // 上點線路
    PermissionType[PermissionType["DEPOSIT_WAY_GROUP_READ"] = 205] = "DEPOSIT_WAY_GROUP_READ";
    // 上點線路 - 編輯
    PermissionType[PermissionType["DEPOSIT_WAY_GROUP"] = 204] = "DEPOSIT_WAY_GROUP";
    // 下點渠道
    PermissionType[PermissionType["WITHDRAW_WAY_SETTING_READ"] = 209] = "WITHDRAW_WAY_SETTING_READ";
    // 下點渠道 - 編輯
    PermissionType[PermissionType["WITHDRAW_WAY_SETTING"] = 208] = "WITHDRAW_WAY_SETTING";
    // 發行單位（銀行卡）黑名單
    PermissionType[PermissionType["DEBIT_CARD_BLACKLIST_READ"] = 203] = "DEBIT_CARD_BLACKLIST_READ";
    // 發行單位（銀行卡）黑名單 - 編輯
    PermissionType[PermissionType["DEBIT_CARD_BLACKLIST"] = 202] = "DEBIT_CARD_BLACKLIST";
    // 支付寶黑名單
    PermissionType[PermissionType["WITHDRAWAL_ACCOUNT_BLACKLIST_READ"] = 213] = "WITHDRAWAL_ACCOUNT_BLACKLIST_READ";
    // 支付寶黑名單 - 編輯
    PermissionType[PermissionType["WITHDRAWAL_ACCOUNT_BLACKLIST"] = 212] = "WITHDRAWAL_ACCOUNT_BLACKLIST";
    // 上點單審核
    PermissionType[PermissionType["GOLDEN_DEPOSIT_MANAGEMENT_READ"] = 253] = "GOLDEN_DEPOSIT_MANAGEMENT_READ";
    // 上點單審核 - 審核
    PermissionType[PermissionType["GOLDEN_DEPOSIT_MANAGEMENT"] = 252] = "GOLDEN_DEPOSIT_MANAGEMENT";
    // 第三方上點審核
    PermissionType[PermissionType["THIRD_PARTY_DEPOSIT_MANAGEMENT_READ"] = 251] = "THIRD_PARTY_DEPOSIT_MANAGEMENT_READ";
    // 第三方上點審核 - 審核
    PermissionType[PermissionType["THIRD_PARTY_DEPOSIT_MANAGEMENT"] = 250] = "THIRD_PARTY_DEPOSIT_MANAGEMENT";
    // 渠道錯誤訊息
    PermissionType[PermissionType["DEPOSIT_ERROR_READ"] = 257] = "DEPOSIT_ERROR_READ";
    // RC 審核
    PermissionType[PermissionType["WITHDRAW_RC_SLIP_READ"] = 311] = "WITHDRAW_RC_SLIP_READ";
    // RC 審核 - 編輯
    PermissionType[PermissionType["WITHDRAW_RC_SLIP"] = 310] = "WITHDRAW_RC_SLIP";
    // RC 審核 - 匯出
    PermissionType[PermissionType["WITHDRAW_RC_SLIP_EXPORT"] = 312] = "WITHDRAW_RC_SLIP_EXPORT";
    // FM 審核
    PermissionType[PermissionType["WITHDRAW_FM_SLIP_READ"] = 301] = "WITHDRAW_FM_SLIP_READ";
    // FM 審核 - 編輯
    PermissionType[PermissionType["WITHDRAW_FM_SLIP"] = 300] = "WITHDRAW_FM_SLIP";
    // FM 審核 - 匯出
    PermissionType[PermissionType["WITHDRAW_FM_SLIP_EXPORT"] = 313] = "WITHDRAW_FM_SLIP_EXPORT";
    // 個人下點設定
    PermissionType[PermissionType["WITHDRAW_LIMIT_SETTING_READ"] = 303] = "WITHDRAW_LIMIT_SETTING_READ";
    // 個人下點設定 - 編輯
    PermissionType[PermissionType["WITHDRAW_LIMIT_SETTING"] = 302] = "WITHDRAW_LIMIT_SETTING";
    // 下點設定
    PermissionType[PermissionType["WITHDRAW_TIP_SETTING_READ"] = 305] = "WITHDRAW_TIP_SETTING_READ";
    // 下點設定 - 編輯
    PermissionType[PermissionType["WITHDRAW_TIP_SETTING"] = 304] = "WITHDRAW_TIP_SETTING";
    // 人工上點
    PermissionType[PermissionType["MANUAL_DEPOSIT_READ"] = 401] = "MANUAL_DEPOSIT_READ";
    // 人工上點 - 編輯
    PermissionType[PermissionType["MANUAL_DEPOSIT"] = 400] = "MANUAL_DEPOSIT";
    // 人工上點 - 匯出
    PermissionType[PermissionType["MANUAL_DEPOSIT_EXPORT"] = 404] = "MANUAL_DEPOSIT_EXPORT";
    // 人工下點
    PermissionType[PermissionType["MANUAL_WITHDRAW_READ"] = 403] = "MANUAL_WITHDRAW_READ";
    // 人工下點 - 編輯
    PermissionType[PermissionType["MANUAL_WITHDRAW"] = 402] = "MANUAL_WITHDRAW";
    // 人工下點 - 匯出
    PermissionType[PermissionType["MANUAL_WITHDRAW_EXPORT"] = 405] = "MANUAL_WITHDRAW_EXPORT";
    // 打碼量紀錄
    PermissionType[PermissionType["EFFECTIVE_CASH_READ"] = 319] = "EFFECTIVE_CASH_READ";
    // 打碼量紀錄 - 編輯
    PermissionType[PermissionType["EFFECTIVE_CASH"] = 318] = "EFFECTIVE_CASH";
    // 活動管理
    PermissionType[PermissionType["ACTIVITY_MANAGEMENT_READ"] = 411] = "ACTIVITY_MANAGEMENT_READ";
    // 活動管理 - 編輯
    PermissionType[PermissionType["ACTIVITY_MANAGEMENT"] = 410] = "ACTIVITY_MANAGEMENT";
    // 控播後台
    PermissionType[PermissionType["LIVE_CONTROL_ADMIN_READ"] = 464] = "LIVE_CONTROL_ADMIN_READ";
    // 玄武後台
    PermissionType[PermissionType["OPEMIM_ADMIN_READ"] = 465] = "OPEMIM_ADMIN_READ";
    // 活動統計
    PermissionType[PermissionType["ACTIVITY_RECORD_READ"] = 489] = "ACTIVITY_RECORD_READ";
    // 活動明細
    PermissionType[PermissionType["ACTIVITY_RECORD_DETAIL_READ"] = 485] = "ACTIVITY_RECORD_DETAIL_READ";
    // 活動申請
    PermissionType[PermissionType["ACTIVITY_APPLICATION_READ"] = 491] = "ACTIVITY_APPLICATION_READ";
    // 活動申請 - 編輯
    PermissionType[PermissionType["ACTIVITY_APPLICATION"] = 490] = "ACTIVITY_APPLICATION";
    // 活動申請 - 匯出
    PermissionType[PermissionType["ACTIVITY_APPLICATION_EXPORT"] = 494] = "ACTIVITY_APPLICATION_EXPORT";
    // 獎勵錢包
    PermissionType[PermissionType["ACTIVITY_WALLET_READ"] = 497] = "ACTIVITY_WALLET_READ";
    // 獎勵錢包 - 編輯
    PermissionType[PermissionType["ACTIVITY_WALLET"] = 498] = "ACTIVITY_WALLET";
    // 獎勵錢包 - 匯出
    PermissionType[PermissionType["ACTIVITY_WALLET_EXPORT"] = 499] = "ACTIVITY_WALLET_EXPORT";
    // 客服中心 - 在線客服
    PermissionType[PermissionType["CUSTOMER_SERVICE_READ"] = 501] = "CUSTOMER_SERVICE_READ";
    // 客服中心 - 案件紀錄搜索
    PermissionType[PermissionType["CS_RECORD_READ"] = 507] = "CS_RECORD_READ";
    /** @deprecated 平台維護設置 */
    PermissionType[PermissionType["PLATFORM_MAINTENANCE_SETTING_READ"] = 557] = "PLATFORM_MAINTENANCE_SETTING_READ";
    /** @deprecated 平台維護設置 - 編輯 */
    PermissionType[PermissionType["PLATFORM_MAINTENANCE_SETTING"] = 556] = "PLATFORM_MAINTENANCE_SETTING";
    // 系統谷歌驗證
    PermissionType[PermissionType["SYS_GOOGLE_AUTH_READ"] = 553] = "SYS_GOOGLE_AUTH_READ";
    // 系統谷歌驗證 - 編輯
    PermissionType[PermissionType["SYS_GOOGLE_AUTH"] = 552] = "SYS_GOOGLE_AUTH";
    // 白名單設置
    PermissionType[PermissionType["IP_WHITELIST_READ"] = 559] = "IP_WHITELIST_READ";
    // 白名單設置 - 編輯
    PermissionType[PermissionType["IP_WHITELIST"] = 558] = "IP_WHITELIST";
    // 帳號管理
    PermissionType[PermissionType["COMPANY_ACCOUNT_MANAGEMENT_READ"] = 601] = "COMPANY_ACCOUNT_MANAGEMENT_READ";
    // 帳號管理 - 編輯
    PermissionType[PermissionType["COMPANY_ACCOUNT_MANAGEMENT"] = 600] = "COMPANY_ACCOUNT_MANAGEMENT";
    // 角色管理
    PermissionType[PermissionType["ROLE_GROUP_SETTING_READ"] = 603] = "ROLE_GROUP_SETTING_READ";
    // 角色管理 - 編輯
    PermissionType[PermissionType["ROLE_GROUP_SETTING"] = 602] = "ROLE_GROUP_SETTING";
    // 後台登入歷程
    PermissionType[PermissionType["LOGIN_SEARCH_READ"] = 608] = "LOGIN_SEARCH_READ";
    // 後台登入歷程 - 總後台登入歷程
    PermissionType[PermissionType["ADMIN_LOGIN_IP_SEARCH_READ"] = 605] = "ADMIN_LOGIN_IP_SEARCH_READ";
    // 後台登入歷程 - 管理後台登入歷程
    PermissionType[PermissionType["AGENT_LOGIN_IP_SEARCH_READ"] = 607] = "AGENT_LOGIN_IP_SEARCH_READ";
    // 異動紀錄
    PermissionType[PermissionType["OPERATION_RECORD_READ"] = 651] = "OPERATION_RECORD_READ";
    // 事件紀錄
    PermissionType[PermissionType["ALERT_RECORD_READ"] = 653] = "ALERT_RECORD_READ";
    // 上点渠道将达停用点数
    PermissionType[PermissionType["ALERT_RECORD_DEPOSIT_WAY_FULL_CASH_REACHED"] = 655] = "ALERT_RECORD_DEPOSIT_WAY_FULL_CASH_REACHED";
    // 转点状态不一致
    PermissionType[PermissionType["ALERT_RECORD_TRANSFER_STATUS_NOT_MATCH"] = 656] = "ALERT_RECORD_TRANSFER_STATUS_NOT_MATCH";
    // 转点记录缺少
    PermissionType[PermissionType["ALERT_RECORD_NO_TRANSFER_LOG_IN_THIRD_PARTY"] = 657] = "ALERT_RECORD_NO_TRANSFER_LOG_IN_THIRD_PARTY";
    // 单笔盈利警示
    PermissionType[PermissionType["ALERT_RECORD_BET_REVENUE_3W"] = 658] = "ALERT_RECORD_BET_REVENUE_3W";
    // 虚拟币地址绑定
    PermissionType[PermissionType["ALERT_RECORD_TRC_BIND"] = 659] = "ALERT_RECORD_TRC_BIND";
    // 会员姓名重复
    PermissionType[PermissionType["ALERT_RECORD_REAL_NAME_DUPLICATE"] = 660] = "ALERT_RECORD_REAL_NAME_DUPLICATE";
    // RC 警示会员进入游戏
    PermissionType[PermissionType["ALERT_RECORD_RC_WARNED_USER_GAME_LOGIN"] = 661] = "ALERT_RECORD_RC_WARNED_USER_GAME_LOGIN";
    // 下点区间盈利警示
    PermissionType[PermissionType["ALERT_RECORD_WITHDRAW_REVENUE_3W"] = 662] = "ALERT_RECORD_WITHDRAW_REVENUE_3W";
    // 绑定重复帐户或地址
    PermissionType[PermissionType["ALERT_RECORD_WALLET_DUPLICATE"] = 663] = "ALERT_RECORD_WALLET_DUPLICATE";
    // 上点单新增频率过高
    PermissionType[PermissionType["ALERT_RECORD_DEPOSIT_ORDER_CREATING_TOO_FREQUENTLY"] = 664] = "ALERT_RECORD_DEPOSIT_ORDER_CREATING_TOO_FREQUENTLY";
    // 三归不符
    PermissionType[PermissionType["ALERT_RECORD_LOCATION_NOT_MATCH"] = 665] = "ALERT_RECORD_LOCATION_NOT_MATCH";
    // 重複指紋
    PermissionType[PermissionType["ALERT_RECORD_DUPLICATE_FINGERPRINT_READ"] = 666] = "ALERT_RECORD_DUPLICATE_FINGERPRINT_READ";
    /** @deprecated 意見反饋 */
    PermissionType[PermissionType["COMPLAIN_READ"] = 701] = "COMPLAIN_READ";
    /** @deprecated 意見反饋 - 編輯 */
    PermissionType[PermissionType["COMPLAIN"] = 700] = "COMPLAIN";
    // Agent Permission
    PermissionType[PermissionType["AGENT_LEVEL_MANAGEMENT"] = 1000] = "AGENT_LEVEL_MANAGEMENT";
    PermissionType[PermissionType["AGENT_ASSISTANT_MANAGEMENT"] = 1001] = "AGENT_ASSISTANT_MANAGEMENT";
    PermissionType[PermissionType["AGENT_ACCOUNT_SEARCH"] = 1002] = "AGENT_ACCOUNT_SEARCH";
    PermissionType[PermissionType["AGENT_DEPOSIT_SYSTEM_SEARCH"] = 1003] = "AGENT_DEPOSIT_SYSTEM_SEARCH";
    PermissionType[PermissionType["AGENT_DEPOSIT_DETAIL_SEARCH"] = 1004] = "AGENT_DEPOSIT_DETAIL_SEARCH";
    PermissionType[PermissionType["AGENT_INFO_SEARCH"] = 1005] = "AGENT_INFO_SEARCH";
    PermissionType[PermissionType["AGENT_SPORT_REPORT"] = 1006] = "AGENT_SPORT_REPORT";
    PermissionType[PermissionType["AGENT_LOTTERY_REPORT"] = 1007] = "AGENT_LOTTERY_REPORT";
    PermissionType[PermissionType["AGENT_GAME_REPORT"] = 1008] = "AGENT_GAME_REPORT";
    PermissionType[PermissionType["AGENT_ACTIVITY_DETAIL_REPORT"] = 1009] = "AGENT_ACTIVITY_DETAIL_REPORT";
    PermissionType[PermissionType["AGENT_SERVICE_CHARGE_REPORT"] = 1010] = "AGENT_SERVICE_CHARGE_REPORT";
    PermissionType[PermissionType["AGENT_PLATFORM_CHARGE_REPORT"] = 1011] = "AGENT_PLATFORM_CHARGE_REPORT";
    PermissionType[PermissionType["AGENT_PLATFORM_REPORT"] = 1012] = "AGENT_PLATFORM_REPORT";
    PermissionType[PermissionType["AGENT_NEWEST_COUPON"] = 1013] = "AGENT_NEWEST_COUPON";
    PermissionType[PermissionType["AGENT_PROMO_LINK"] = 1014] = "AGENT_PROMO_LINK";
    PermissionType[PermissionType["AGENT_DEPOSIT"] = 1015] = "AGENT_DEPOSIT";
    PermissionType[PermissionType["AGENT_WITHDRAW_DETAIL_SEARCH"] = 1016] = "AGENT_WITHDRAW_DETAIL_SEARCH";
    PermissionType[PermissionType["AGENT_WALLET_TRANSFER"] = 1017] = "AGENT_WALLET_TRANSFER";
    PermissionType[PermissionType["AGENT_WALLET_DEPOSIT"] = 1018] = "AGENT_WALLET_DEPOSIT";
    PermissionType[PermissionType["AGENT_WALLET_HISTORY"] = 1019] = "AGENT_WALLET_HISTORY";
    PermissionType[PermissionType["AGENT_AGENT_ANNOUNCEMENT"] = 1020] = "AGENT_AGENT_ANNOUNCEMENT";
    PermissionType[PermissionType["AGENT_ACTIVITY_STATISTIC_REPORT"] = 1021] = "AGENT_ACTIVITY_STATISTIC_REPORT";
    PermissionType[PermissionType["AGENT_CAN_SEE_ANNOUNCEMENT"] = 1022] = "AGENT_CAN_SEE_ANNOUNCEMENT";
    PermissionType[PermissionType["AGENT_CAN_SEE_ACTIVITY"] = 1023] = "AGENT_CAN_SEE_ACTIVITY";
})(PermissionType || (PermissionType = {}));
//# sourceMappingURL=PermissionType.js.map